import { ActionReducerMap, createFeatureSelector } from '@ngrx/store';
import { IAppRootState } from 'src/app/core/store';

import { mapOriginalReducer } from './map.reducer';
import { MapMainSliceState, MapSliceKey } from './map.state';

export const MapFeatureKey = 'Map';

export interface MapFeatureState {
	[MapSliceKey]: MapMainSliceState;
}

export interface MapRootState extends IAppRootState {
	[MapFeatureKey]: MapFeatureState;
}

export const featureSelector =
	createFeatureSelector<MapFeatureState>(MapFeatureKey);

export const mapReducers: ActionReducerMap<MapFeatureState> = {
	[MapSliceKey]: mapOriginalReducer,
};
